import { render, staticRenderFns } from "./LandingHero2.vue?vue&type=template&id=72d5dd1e&scoped=true"
import script from "./LandingHero2.vue?vue&type=script&lang=js"
export * from "./LandingHero2.vue?vue&type=script&lang=js"
import style0 from "./LandingHero2.vue?vue&type=style&index=0&id=72d5dd1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5dd1e",
  null
  
)

export default component.exports